import { lazy, Suspense } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Lazy load the wizard to reduce initial bundle size
const OnboardingWizard = lazy(() => import('../pages/OnboardingWizard'));

function RouteFallback() {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
      <CircularProgress />
    </Box>
  );
}

export function OnboardingManager() {
  const { user } = useAuth();
  const location = useLocation();

  // Optimization: Only render the wizard if the user is a trade company.
  // Customers, admins, and unauthenticated users do not need to load this chunk
  // or execute its logic (which involves multiple DB calls).
  if (!user?.trade_company_id) {
    return null;
  }

  // Prevent the onboarding wizard from overlaying auth and password reset pages
  // This ensures new users can set their password without the wizard blocking the UI
  if (
    location.pathname === '/reset-password' ||
    location.pathname === '/auth/callback'
  ) {
    return null;
  }

  return (
    <Suspense fallback={<RouteFallback />}>
      <OnboardingWizard />
    </Suspense>
  );
}
